var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo';
                    var viewUrl = 'sprite.svg#view-logo';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo#logo';
                            viewUrl = 'sprite.svg?logo#view-logo';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 340.2 71.2',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };